/**
 * Created by staffanrantzow on 15/04/16.
 */

export default class CurrencyEntity {

  constructor (
    id,
    active,
    code,
    exchangeRate,
    name,
    standard,
    updatedAt
  ) {
    this.id = id;
    this.active = active;
    this.code = code;
    this.exchangeRate = exchangeRate;
    this.name = name;
    this.standard = standard;
    this.updatedAt = updatedAt;
  }

}



/** WEBPACK FOOTER **
 ** ./src/frilans-finans/currencies/currency-entity.js
 **/